export function groupItems<T>(
  data: T[],
  groupBy: (item: T) => string
): Array<{ value: string; items: T[] }> {
  const map = new Map<string, T[]>();
  for (const item of data) {
    const key = groupBy(item);
    if (!map.has(key)) map.set(key, []);
    map.get(key)!.push(item);
  }
  return Array.from(map.entries()).map(([value, items]) => ({ value, items }));
}
